import nivoSlider from '../lib/jquery.nivo.slider.js';
import 'jquery.easing';

export function sliderFunc() {
  let slider = $('#slider');
  slider.nivoSlider({
    effect: 'fold',
    slices: 3,
    animSpeed: 800,
    pauseTime: 3000,
    directionNav: false,
    controlNav: false,
    easing: 'easeOutQuint'
  });
}
